////////LIBRARY/////////
import { isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { errorManagerActionCreators, globalLoadingActionCreators, loginActionCreators, modalsActionCreators } from '../actions'

// Cle de traduction renvoyee par le back sur un echec d'AUTHENTIFICATION : jeton absent,
// expire ou invalide (AuthExceptionEntryPoint -> DisplayMessageEnum.LOGIN_FAILED) ainsi que
// IS_NOT_USER_CONNECTED_CONTEXT, qui partagent la meme cle. Les 401 d'AUTORISATION en ont
// d'autres (common__message__rolePrivilege_notAutorized, common__message__data_notAutorized)
// et doivent continuer d'afficher une modale.
const AUTH_LOST_TRAD_KEY = 'common__message__login_connexion_unauthorized'

const createError = function* ({ payload }) {
	const error = payload.error
	const redirectPath = payload.redirectPath
	let modal
	const modalTitle = {
		title: 'modal__validationFailed',
	}
	yield put(globalLoadingActionCreators.endLoading())
	if (!isUndefined(error)) {
		if (!isUndefined(error.status)) {
			switch (error.status) {
				/* case 500:
					modal = {
						level: 'error',
						title: 'modal__errorDefault__title',
						key: 'modal__errorDefault__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break */

				case 503:
					yield put(errorManagerActionCreators.modeMaintenance('/maintenance'))
					break

				case 404:
					modal = {
						level: 'error',
						title: 'modal__error404__title',
						key: 'modal__error404__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 200:
					modal = {
						level: 'error',
						title: 'modal__error200PartialSuccess__title',
						key: 'modal__error200PartialSuccess__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 400:
					modal = {
						level: 'error',
						title:
							error.data.traductionKey === 'common__message__company_labelCommercial_alreadyExist'
								? modalTitle.title
								: 'modal__error400__title',
						key: error.data.traductionKey,
						errorMsgParams: error.data.msgParameters,
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}
					yield put(modalsActionCreators.hydrateModal(modal))
					break

				case 401: {
					const isConnected = yield select((state) => state.user.isConnected)
					const isAuthLost = !isUndefined(error.data) && error.data.traductionKey === AUTH_LOST_TRAD_KEY

					// Session perdue : rien a faire acquitter a l'utilisateur. On le deconnecte,
					// PrivateRoutes le renvoie alors automatiquement sur /login.
					if (isConnected && isAuthLost) {
						yield put(modalsActionCreators.closeModal())
						yield put(loginActionCreators.getLogout())
						break
					}

					// Autres 401 (autorisations insuffisantes, erreurs metier) : modale, sans
					// redirection forcee puisque la session est toujours valide.
					modal = {
						level: 'error',
						title: 'modal__error401__title',
						key: error.data.traductionKey,
						errorMsgParams: error.data.msgParameters,
						show: true,
						path: redirectPath !== '' ? redirectPath : '',
						insideModalResponse: true,
					}
					yield put(modalsActionCreators.hydrateModal(modal))
					break
				}

				default:
					modal = {
						level: 'error',
						title: 'modal__errorDefault__title',
						key: 'modal__errorDefault__body',
						show: true,
						path: redirectPath,
						insideModalResponse: true,
					}

					yield put(modalsActionCreators.hydrateModal(modal))
					break
			}
		} else {
			modal = {
				level: 'error',
				title: 'modal__errorDefault__title',
				key: 'modal__errorDefault__body',
				show: true,
				path: redirectPath,
				insideModalResponse: true,
			}
			yield put(modalsActionCreators.hydrateModal(modal))
		}
	} else {
		modal = {
			level: 'error',
			title: 'modal__errorDefault__title',
			key: 'modal__errorDefault__body',
			show: true,
			path: redirectPath,
			insideModalResponse: true,
		}
		yield put(modalsActionCreators.hydrateModal(modal))
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.CREATE_ERROR, createError)
}

export default sagas
